import { Modal, Button } from 'react-bootstrap'
import { Alert, AlertTitle } from '@material-ui/lab'
import NotInterestedIcon from '@material-ui/icons/NotInterested'
import api from '../../services/api'
import history from '../../history'
const CorpoMon = ({ data }) => {
  function handlePushEmpresas() {
    localStorage.setItem('idEmpresa', data._id)
    localStorage.setItem('name_empresa', data.name)
    history.push('/reportsemanal')
  }
  function refreshPage(info) {
    window.location.reload(info)
  }

  async function cleanErrors() {
    await api
      .post('/clean/errosbkp', {
        id: data._id,
      })
      .then(() => {
        refreshPage()
      })
      .catch(() => {
        console.log('Erro')
      })
  }
  return (
    <div>
      <Alert
        icon={<NotInterestedIcon />}
        severity="error"
        action={
          <Button variant="danger" size="sm" onClick={handlePushEmpresas}>
            Verificar
          </Button>
        }
      >
        <AlertTitle>
          {' '}
          {data.name} tem backups que não foram executados{' '}
          <Button variant="warning" size="sm" onClick={cleanErrors}>
            Limpar erro?
          </Button>
        </AlertTitle>
      </Alert>
    </div>
  )
}

export default CorpoMon
